const BESTSELLERS = [
  {
    title: "Grilled Paneer with Salad",
    desc: "Indulge in the delectable harmony of grilled paneer & fresh, vibrant salad greens",
    isVeg: true,
    isNew: true,
    src: "/images/bestsellers/grilled-paneer.png",
  },
  {
    title: "Paneer Post Workout Meal",
    desc: "Recharge post-workout with our nutritious paneer meal, packed with protein & essential nutrients",
    isVeg: true,
    isNew: true,
    src: "/images/bestsellers/paneer-post-workout-meal.png",
  },
  {
    title: "Paneer Salad",
    desc: "Savor a delightful crunch & creamy goodness in every bite with our paneer salad",
    isVeg: true,
    isNew: true,
    src: "/images/bestsellers/paneer-salad.png",
  },
  {
    title: "Grilled Chicken with Salad",
    desc: "Juicy grilled chicken harmonizes with crisp, vibrant salad greens in a tantalizing culinary fusion",
    isVeg: false,
    isNew: true,
    src: "/images/bestsellers/grilled-chicken-with-salad.png",
  },
  {
    title: "Chicken Post Workout Meal",
    desc: "Replenish & refuel your post-workout with our protein-packed chicken meal",
    isVeg: false,
    isNew: true,
    src: "/images/bestsellers/chicken-post-workout-meal.png",
  },
  {
    title: "Chicken Salad",
    desc: "A wholesome blend of tender chicken, crisp greens, & zesty dressing",
    isVeg: false,
    isNew: true,
    src: "/images/bestsellers/chicken-salad.png",
  },
];

export default BESTSELLERS;
